import React from 'react';
import { QuickBasketLine } from '@/components/shared/BasketLine/QuickBasketLine';
import { PurchaseLineResponse } from '@/generated/data.schemas';
import styles from './BasketLine.module.scss';
import { DefaultBasketLine } from './DefaultBasketLine';

export interface BasketLineProps {
	line: PurchaseLineResponse;
	variant?: 'default' | 'applicationLine' | 'additional';
	label?: string;
	isFull?: boolean;
	isQuantityReadOnly?: boolean;
	isQuickBasket?: boolean;
	isLinkDisabled?: boolean;
	isRemoveDisabled?: boolean;
	isRemoveQuantityDisabled?: boolean;
	categories?: string[];
	enableDiscount?: boolean;
}

export const BasketLine: React.FunctionComponent<BasketLineProps> = (props) => {
	const { line, variant, label } = props;
	const { isQuickBasket, enableDiscount, ...rest } = props;

	return (
		<div className={styles.lineWrapper}>
			{isQuickBasket ? (
				<QuickBasketLine line={line} variant={variant} label={label} />
			) : (
				<DefaultBasketLine {...rest} enableDiscount={enableDiscount} />
			)}
		</div>
	);
};
